import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from '@app/app.module'
import { INITIAL_LOCALE, SET_LOCALE } from '@core/util/space.util'
import { INITIAL_TZ, SET_TZ } from '@core/util/time.util'
import { environment } from '@env/environment'

if (environment.production) {
  enableProdMode()
}

// init default space-time with luxon
// space
SET_LOCALE(INITIAL_LOCALE)
// time
SET_TZ(INITIAL_TZ)

platformBrowserDynamic().bootstrapModule(AppModule).catch(err => { console.error(err) })
